import React, { useState } from 'react'
import { connect } from 'react-redux';
import { object, string } from 'yup';
import { useFormik } from 'formik';

// Store
import { Dispatch, RootState } from '../../store/store';

// Types
import { ElementSize } from '../../types/element-size';

// Components
import InputControl from '../InputControl/InputControl';
import IconLock from '../Icons/Lock/Lock';
import SpinnerLoader from '../SpinnerLoader/SpinnerLoader';
import InteractiveButton from '../InteractiveButton/InteractiveButton';

type CodeFormProps = {
  email: string
} & ReturnType<typeof mapDispatch> & ReturnType<typeof mapState>;

const CodeForm: React.FC<CodeFormProps> = (props) => {
  const { redeemInvitationCode, email, isAuthLoading } = props;

  // States
  const [isShowPwd, setIsShowPwd] = useState<boolean>(true);

  const loadingClassName = isAuthLoading ? 'flex-auto justify-center items-center' : 'flex-col w-full';
  const codeFormClassName = `c-code-form flex  ${loadingClassName}`;

  // Logic
  const formik = useFormik({
    initialValues: {
      code: '',
    },
    validationSchema: object({
      code: string().required('Required'),
    }),
    onSubmit: (values) => {
      redeemInvitationCode({ email, code: values.code });
    },
  });

  const isDisabledBtn = Boolean(formik.touched.code && formik.errors.code);

  const changePwdVisibility = () => setIsShowPwd(!isShowPwd);

  return (
    <div className={codeFormClassName}>
      {!isAuthLoading ? (
        <form className='flex-auto' onSubmit={formik.handleSubmit}>
          <div className="pb-3" >
            <InputControl
              label='Please check your email and copy the verification code sent to you'
              type="password"
              name='code'
              placeholder="Enter code"
              value={formik.values.code}
              customOnChange={formik.handleChange}
              showPwd={isShowPwd}
              changePwdVisibility={changePwdVisibility}
              showError={formik.touched.code && formik.errors.code}
              errorText={formik.errors.code}
              iconRight={<IconLock size={ElementSize.MD} />}
            />
          </div>
          <InteractiveButton
            text='Please Log In'
            submit
            disabled={isDisabledBtn}
            size={ElementSize.XL}
            className="w-full"
          />
        </form>
      ) : (
        <SpinnerLoader />
      )}
    </div>
  )
}

const mapState = (state: RootState) => ({
  isAuthLoading: state.auth.isAuthLoading,
});

const mapDispatch = (dispatch: Dispatch) => ({
  redeemInvitationCode: dispatch.auth.redeemInvitationCode,
});

export default connect(mapState, mapDispatch)(CodeForm);
